import React from 'react';
import { useDispatch } from 'react-redux';
import { setStylePackTypeFilter } from '../../stores/actions/user-interface';
import { ICONS } from '../general-components/icon';
import StylePackFilterBubble from './style-pack-filter-bubble';
import { StylePackContentType } from '../types/stylepacks';


enum SPCLabel {
	SEGMENT = 'Segments',
	LOWER_THIRDS = 'Lowers',
	COUNTDOWN = 'Countdowns',
	WALKUP = 'Walkups',
	TRANSITION = 'Bookends',
	BOOKEND = 'Bookends',
	ALL = 'All',
}

export default function StylePacksFilters() {
	const dispatch = useDispatch();

	return (<>
		<div className='style-packs-bubble-filters' data-testid="style-packs-filters">
			{/* try not to map-render these, as they have animations and can be slow */}
			<StylePackFilterBubble
				text={SPCLabel.ALL}
				icon={ICONS.FILTER_STYLEPACKS}
				onClick={(f) => dispatch(setStylePackTypeFilter(f))}
				type={undefined}
			/>
			<StylePackFilterBubble
				text={SPCLabel.LOWER_THIRDS}
				icon={ICONS.FILTER_LOWERS}
				onClick={(f) => dispatch(setStylePackTypeFilter(f))}
				type={StylePackContentType.TITLE}
			/>
			<StylePackFilterBubble
				text={SPCLabel.WALKUP}
				icon={ICONS.FILTER_WALKUPS}
				onClick={(f) => dispatch(setStylePackTypeFilter(f))}
				type={StylePackContentType.WALKUP}
			/>
			<StylePackFilterBubble
				text={SPCLabel.SEGMENT}
				icon={ICONS.FILTER_SEGMENTS}
				onClick={(f) => dispatch(setStylePackTypeFilter(f))}
				type={StylePackContentType.SEGMENT}
			/>
			<StylePackFilterBubble
				text={SPCLabel.COUNTDOWN}
				icon={ICONS.FILTER_COUNTDOWNS}
				onClick={(f) => dispatch(setStylePackTypeFilter(f))}
				type={StylePackContentType.COUNTDOWN}
			/>
			<StylePackFilterBubble
				text={SPCLabel.BOOKEND}
				icon={ICONS.FILTER_BOOKENDS}
				onClick={(f) => dispatch(setStylePackTypeFilter(f))}
				type={StylePackContentType.BOOKEND}
			/>
		</div>
	</>);
}
